<div *ngIf="config?.paymentOptions?.options" class="payment-options-wrapper">

  <!-- payment options tabs for desktop -->
  <div *ngIf="!isMobile" class="option-bar">
    <button *ngFor="let item of options" (click)="setOption(item)" [ngClass]="{'op__active': qprams?.method === item.order_mode}" mat-button>
      <div class="op-icon">
        <span class="material-icons">{{item.icon}}</span>
      </div>
      <div class="op-name">
        <div>{{item.label}}</div>
        <div *ngIf="item?.order_mode === config?.paymentOptions?.options?.RECOMMENDED" class="recommended">RECOMMENDED</div>
      </div>
    </button>
  </div>

  <!-- payment options menu list for mobile -->
  <div *ngIf="isMobile && !qprams?.method" class="option-menu">

    <!-- previously used payment options by user -->
    <div *ngIf="config?.paymentOptions?.options?.PREVIOUSPAYMENTGATEWAY" class="pre-used">
      <div class="head">
        <span class="title">Previously Used</span>
        <span class="recommended" *ngIf="options?.length > 1">RECOMMENDED</span>
      </div>
      <app-payment-pre-used [config]="config" (dataEmit)="submit($event)"></app-payment-pre-used>
    </div>

    <!--payment options -->
    <div *ngIf="config?.currency === 'INR'">
      <ng-container *ngTemplateOutlet="optionsRef; context: { option: config?.paymentOptions?.options?.TOPUPI, label: 'UPI', mode: 'UPI', list: util.getMobileOperatingSystem() !== 'iOS' }"></ng-container>
      <ng-container *ngTemplateOutlet="optionsRef; context: { option: config?.paymentOptions?.options?.TOPNB, label: 'Net Banking', mode: 'NB', list: true }"></ng-container>
      <ng-container *ngTemplateOutlet="optionsRef; context: { option: config?.paymentOptions?.options?.TOPWALLET, label: 'Wallets', mode: 'WALLET', list: true }"></ng-container>
    </div>

    <!-- Card Option -->
    <div class="payment-options card-option" (click)="viewAll('CARD')">
      <span class="material-icons add">add</span>
      <div class="mr-auto">
        <div class="option-title">Add New Card</div>
        <div class="option-subtitle">Visa, Mastercard, American Express...</div>
      </div>
      <span class="material-icons">navigate_next</span>
    </div>
  </div>

  <!-- payment options screens like cards, upi, wallet etc -->
  <div class="option-screen" [ngClass]="'_'+qprams?.method" [hidden]="!(qprams?.method)">
    <div class="op-item PU" [hidden]="!(qprams?.method === 'PREVIOUSPAYMENTGATEWAY')">
      <app-payment-pre-used [config]="config" (dataEmit)="submit($event)"></app-payment-pre-used>
    </div>

    <div class="op-item CARD" [hidden]="!(qprams?.method === 'CARD')">
      <div class="header">
        <div class="add-card">
          <div class="title">Add New Card</div>
          <div class="sub-title">Save and Pay Via Cards</div>
        </div>
        <div class="supported">
          <span *ngFor="let item of config?.supported_cards" class="payment-icons-v1" [ngClass]="item"></span>
        </div>
      </div>
      <app-payment-sip-card [config]="config" (dataEmit)="submit($event)"></app-payment-sip-card>
    </div>

    <div class="op-item NB" [hidden]="!(qprams?.method === 'NB')">
      <app-payment-netbanking [config]="config" (dataEmit)="submit($event)"></app-payment-netbanking>
    </div>

    <div class="op-item" [hidden]="!(qprams?.method === 'PAYTM')">
      <app-qrcode-box [config]="config" [code]="paymentV2?.paytmQrCode" title="Scan this code to pay with Paytm Wallet" icons="paytm"></app-qrcode-box>
    </div>

    <div class="op-item UPI" [hidden]="!(qprams?.method === 'UPI')">
      <app-payment-upi [config]="config" (dataEmit)="submit($event)"></app-payment-upi>
    </div>

    <div class="op-item WALLET" [hidden]="!(qprams?.method === 'WALLET')">
      <app-payment-wallet [config]="config" (dataEmit)="submit($event)"></app-payment-wallet>
    </div>

    <div class="payment-button" *ngIf="!isMobile || qprams?.method=='CARD'">
      <app-payment-sip-button [config]="config" (btnClick)="paymentV2.pledgeBtn.next(selectedTab?.name)"></app-payment-sip-button>
    </div>
  </div>
</div>

<!-- time screen for upi payment -->
<app-payment-sip-upi-timer *ngIf="vars.upiTimer"></app-payment-sip-upi-timer>

<ng-template #optionsRef let-option="option" let-label="label" let-mode="mode" let-list="list">
  <div class="payment-options" *ngIf="option">
    <div class="head">
      <div class="title">{{label}}</div>
      <span class="recommended" *ngIf="config?.paymentOptions?.options?.RECOMMENDED===mode">RECOMMENDED</span>
      <button *ngIf="list" class="view-all" (click)="viewAll(mode)" mat-button>
        <strong>{{mode=='UPI' ? 'Enter UPI ID':'View all'}}</strong> <span class="material-icons">chevron_right</span>
      </button>
    </div>

    <!-- For payment option list -->
    <div *ngIf="list" class="option-list">
      <div class="option-wrapper" *ngFor="let item of option | keyvalue">
        <button (click)="submit({mode: mode, mode_value: item.key})" class="option-btn" mat-button>
          <div [class]="'payment-icons-v1 '+ (item.key | uppercase)" [ngClass]="{'loader-key': paymentV2.isOrderLoading && submitData?.mode_value===item.key}">
            <div *ngIf="paymentV2.isOrderLoading && submitData?.mode_value===item.key" class="dots-loader"><span></span></div>
          </div>
        </button>
        <div class="option-label">{{item.value?.split(' ')[0]}}</div>
      </div>
    </div>

    <!-- For IOS UPI Option -->
    <div *ngIf="mode=='UPI' && util.getMobileOperatingSystem() === 'iOS'">
      <app-payment-sip-upi [config]="config" [showTime]="false" (dataEmit)="submit($event)"></app-payment-sip-upi>
      <app-payment-sip-button [config]="config" (btnClick)="onVpaSubmitButton()"></app-payment-sip-button>
      <div class="upi-input-label">
        <span class="under-text">Pay with any BHIM/UPI app</span>
        <span>
          <span *ngFor="let item of option | keyvalue" [class]="'payment-icons-v1 '+ (item.key | uppercase)"></span>
        </span>
      </div>
    </div>
  </div>
</ng-template>